// extracted by mini-css-extract-plugin
module.exports =  {"form":"PM_Arw"};